<template>
  <div class="login-container">
    <div class="login-box">
      <div class="login-brand">
        <span class="login-brand__mark" aria-hidden="true"></span>
        <span class="login-brand__name">足彩助手</span>
      </div>
      <p class="login-sub">输入手机号与验证码登录</p>
      <div class="input-group">
        <input 
          type="text" 
          v-model="phone" 
          placeholder="请输入手机号"
          @input="validatePhone"
        >
        <button 
          @click="getVerificationCode" 
          :disabled="!isPhoneValid || countdown > 0"
        >
          {{ countdown > 0 ? `${countdown}秒后重试` : '获取验证码' }}
        </button>
      </div>
      <div class="error-message" v-if="phoneError">
        {{ phoneError }}
      </div>
      
      <div class="input-group">
        <input 
          type="text" 
          v-model="verificationCode" 
          placeholder="请输入验证码"
          @input="validateCode"
        >
      </div>
      
      <button 
        class="login-button" 
        @click="login"
        :disabled="!isCodeValid"
      >
        登录
      </button>
    </div>
  </div>
</template>

<script>
import { validateChinesePhone, validateVerificationCode } from '../utils/validators'
import axios from 'axios'
import { Message } from 'ant-design-vue';

export default {
  name: 'Login',
  data() {
    return {
      phone: '',
      verificationCode: '',
      phoneError: '',
      isPhoneValid: false,
      isCodeValid: false,
      countdown: 0,
      timer: null
    }
  },
  methods: {
    validatePhone() {
      this.isPhoneValid = validateChinesePhone(this.phone)
      this.phoneError = this.isPhoneValid ? '' : '请输入有效的中国大陆手机号'
    },
    validateCode() {
      this.isCodeValid = validateVerificationCode(this.verificationCode)
    },
    async getVerificationCode() {
      if (!this.isPhoneValid) return
      
      try {
        await axios.post('YOUR_API_URL/send-code', {
          phone: this.phone
        })
        
        this.countdown = 60
        this.startCountdown()
      } catch (error) {
        console.error('发送验证码失败:', error)
      }
    },
    startCountdown() {
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--
        } else {
          clearInterval(this.timer)
        }
      }, 1000)
    },
    async login() {
      if (!this.isPhoneValid || !this.isCodeValid) return
      console.log("code:", this.verificationCode)
      // if (this.verificationCode === '123678') {
      //   localStorage.setItem('isLoggedIn', 'true')
      //   this.$router.push('/home')
      //   return
      // }
      try {
        // const response = await axios.post('YOUR_API_URL/verify-code', {
        // const response = await axios.get('https://api.ip008.com/odds/test.php')
        const response = await axios.post('https://api.ip008.com/odds/login.php', {
          phone: this.phone,
          code: this.verificationCode
        })
        
        if (response.data.success) {
          localStorage.setItem('isLoggedIn', 'true')
          localStorage.setItem('userId', response.data.userId)
          localStorage.setItem('phone', this.phone)
          // commit('SET_MATCHES', response.data)
          this.$router.push('/home')
        }
        else {
          console.log(response.data)
          // Message.error('登录失败，请重新输入验证码')
        }
      } catch (error) {
        console.error('登录失败:', error)
      }
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 20px;
  background:
    radial-gradient(120% 80% at 50% -10%, rgba(26, 122, 76, .12), transparent 60%),
    var(--turf-bg);
}

.login-box {
  background-color: var(--surface);
  padding: 32px 28px;
  border-radius: var(--r);
  border: 1px solid var(--line);
  box-shadow: var(--shadow-lg);
  width: 100%;
  max-width: 380px;
}

.login-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 22px;
  font-weight: 700;
  color: var(--pitch-900);
}
.login-brand__mark {
  width: 26px;
  height: 26px;
  border-radius: 7px;
  background: var(--pitch-600);
  position: relative;
  flex: none;
}
.login-brand__mark::before {
  content: "";
  position: absolute;
  left: 50%; top: 4px; bottom: 4px;
  width: 2px;
  transform: translateX(-50%);
  background: rgba(255, 255, 255, .7);
}
.login-brand__mark::after {
  content: "";
  position: absolute;
  left: 50%; top: 50%;
  width: 8px; height: 8px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, .7);
  transform: translate(-50%, -50%);
}
.login-sub {
  margin: 8px 0 24px;
  color: var(--ink-soft);
  font-size: 14px;
}

.input-group {
  margin-bottom: 16px;
  display: flex;
  gap: 10px;
}

input {
  flex: 1;
  min-width: 0;
  padding: 11px 12px;
  border: 1px solid var(--line);
  border-radius: var(--r-sm);
  font-size: 15px;
  transition: border-color .15s ease, box-shadow .15s ease;
}
input:focus {
  outline: none;
  border-color: var(--pitch-500);
  box-shadow: 0 0 0 2px rgba(26, 122, 76, .14);
}

button {
  padding: 11px 18px;
  background-color: var(--pitch-600);
  color: white;
  border: none;
  border-radius: var(--r-sm);
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color .15s ease;
}
button:hover:not(:disabled) {
  background-color: var(--pitch-500);
}
button:disabled {
  background-color: #C7D2CB;
  cursor: not-allowed;
}

.login-button {
  width: 100%;
  margin-top: 4px;
}

.error-message {
  color: var(--loss);
  font-size: 13px;
  margin: -8px 0 12px;
}
</style>